import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Label } from './ui/label';
import { METIERS_COPPAM } from './simulateurTarifData';

// Sélection des métiers d'activité (partagée entre modes souscription et avenant).
export function MetiersSelection({ metiersSelectionnes, toggleMetier, t }) {
  return (
    <div>
      <Label className="mb-3 block">{t('simulateur.select_trades', 'Sélectionnez vos métiers d\'activité')}</Label>
      <div className="space-y-4">
        {Object.entries(METIERS_COPPAM).map(([catKey, catData]) => (
          <div key={catKey} className="border rounded-lg p-4" style={{ borderColor: catData.couleur + '40' }}>
            <h3 className="font-semibold mb-3 flex items-center gap-2" style={{ color: catData.couleur }}>
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: catData.couleur }}></div>
              {catData.label}
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {Object.entries(catData.metiers).map(([metierNom, metierData]) => {
                const key = `${catKey}|||${metierNom}`;
                const isSelected = !!metiersSelectionnes[key];

                return (
                  <button
                    key={key}
                    type="button"
                    onClick={() => toggleMetier(catKey, metierNom)}
                    className={`p-2 text-sm rounded border transition-all ${
                      isSelected
                        ? 'border-blue-600 bg-blue-50 text-blue-900 font-medium'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className="flex items-center gap-2">
                      {isSelected && <CheckCircle2 className="h-4 w-4 text-blue-600" />}
                      <span className="flex-1 text-left">{metierNom}</span>
                    </div>
                    <div className="text-xs text-gray-500 mt-1">
                      Coef: {(metierData.coefficient * 100).toFixed(2)}%
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Carte de résultat du calcul (partagée entre modes souscription et avenant).
export function ResultatCalcul({ resultatCalcul, mode }) {
  if (!resultatCalcul) return null;
  return (
    <Card className={`${mode === 'avenant' ? 'bg-gradient-to-br from-purple-50 to-indigo-50' : 'bg-gradient-to-br from-blue-50 to-indigo-50'}`}>
      <CardHeader>
        <CardTitle className={mode === 'avenant' ? 'text-purple-900' : 'text-blue-900'}>
          {mode === 'avenant' ? 'Tarification de l\'Avenant' : 'Résultat de la Simulation'}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-600">Chiffre d'Affaires</p>
            <p className="text-lg font-semibold">{resultatCalcul.chiffreAffaires.toLocaleString('fr-FR')} €</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Métiers sélectionnés</p>
            <p className="text-lg font-semibold">{resultatCalcul.nombreMetiers}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Coefficient moyen</p>
            <p className="text-lg font-semibold">{(resultatCalcul.coefficientMoyen * 100).toFixed(2)}%</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">TVA (8.5%)</p>
            <p className="text-lg font-semibold">{resultatCalcul.tva.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €</p>
          </div>
        </div>

        <div className="border-t pt-4 mt-4">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm text-gray-600">Montant de base</p>
              <p className={`text-2xl font-bold ${mode === 'avenant' ? 'text-purple-900' : 'text-blue-900'}`}>
                {resultatCalcul.montantHT.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €
              </p>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-600">Montant Global</p>
              <p className="text-2xl font-bold text-green-700">
                {resultatCalcul.montantTTC.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
